(() => {
  const STAR_PATH =
    'M14.3842 4.28107C14.982 2.84381 17.0181 2.84381 17.6159 4.28107L20.3918 10.9554L27.5973 11.533C29.1489 11.6574 29.7781 13.5938 28.5959 14.6065L23.1061 19.3091L24.7834 26.3404C25.1445 27.8545 23.4973 29.0513 22.1689 28.2399L16 24.4719L9.83117 28.2399C8.50275 29.0513 6.85556 27.8545 7.21674 26.3404L8.89396 19.3091L3.40416 14.6065C2.22198 13.5938 2.85114 11.6574 4.40279 11.533L11.6082 10.9554L14.3842 4.28107Z';

  const COLORS = {
    on: '#00D390',
    off: '#EDE2D0',
    half: 'url(#jdgm-devine-half)',
  };

  function starSvg(fill) {
    const defs =
      fill === COLORS.half
        ? `<defs><linearGradient id="jdgm-devine-half" x1="0" y1="0" x2="1" y2="0"><stop offset="50%" stop-color="#00D390"/><stop offset="50%" stop-color="#EDE2D0"/></linearGradient></defs>`
        : '';
    return `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">${defs}<path fill-rule="evenodd" clip-rule="evenodd" d="${STAR_PATH}" fill="${fill}"/></svg>`;
  }

  function fillFor(el) {
    if (el.classList.contains('jdgm--on')) return COLORS.on;
    if (el.classList.contains('jdgm--half')) return COLORS.half;
    return COLORS.off;
  }

  function paintStar(el) {
    if (!(el instanceof HTMLElement)) return;
    if (!el.classList.contains('jdgm-star')) return;
    const fill = fillFor(el);
    if (el.dataset.devineStar === fill && el.querySelector('svg')) return;
    el.dataset.devineStar = fill;
    el.innerHTML = starSvg(fill);
  }

  function paintAll(root = document) {
    root.querySelectorAll?.('.jdgm-star').forEach(paintStar);
  }

  /** Move reviewer name to the start of the review card. */
  function moveNameToStart(root = document) {
    root.querySelectorAll?.('.jdgm-carousel-item__review').forEach((review) => {
      if (!(review instanceof HTMLElement)) return;

      const name = review.querySelector(':scope > .jdgm-carousel-item__reviewer-name-wrapper')
        || review.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      if (!name) return;

      if (review.firstElementChild !== name) {
        review.insertBefore(name, review.firstChild);
      }
      review.dataset.devineNameStart = 'true';
    });

    // Fallback: if name sits outside __review, put it at the start of the card item.
    root.querySelectorAll?.('.jdgm-carousel-item').forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      const review = item.querySelector('.jdgm-carousel-item__review');
      const name = item.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      if (!name || !review) return;
      if (review.contains(name)) return;
      review.insertBefore(name, review.firstChild);
    });
  }

  /** Move rating stars to the end (bottom) of the review card. */
  function moveRatingToEnd(root = document) {
    root.querySelectorAll?.('.jdgm-carousel-item__review').forEach((review) => {
      if (!(review instanceof HTMLElement)) return;

      const rating =
        review.querySelector(':scope > .jdgm-carousel-item__review-rating') ||
        review.querySelector('.jdgm-carousel-item__review-rating');
      if (!rating) return;

      if (review.lastElementChild !== rating) {
        review.appendChild(rating);
      }
    });

    root.querySelectorAll?.('.jdgm-carousel-item').forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      const review = item.querySelector('.jdgm-carousel-item__review');
      const rating = item.querySelector('.jdgm-carousel-item__review-rating');
      if (!rating || !review) return;
      if (review.contains(rating)) {
        if (review.lastElementChild !== rating) review.appendChild(rating);
        return;
      }
      review.appendChild(rating);
    });
  }

  function enhance(root = document) {
    moveNameToStart(root);
    moveRatingToEnd(root);
    paintAll(root);
  }

  function start() {
    enhance();

    const observer = new MutationObserver((mutations) => {
      let needsEnhance = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches?.('.jdgm-star')) paintStar(node);
            else if (
              node.matches?.('.jdgm-carousel-item__review, .jdgm-carousel-wrapper, .jdgm-carousel-item') ||
              node.querySelector?.('.jdgm-star, .jdgm-carousel-item__review')
            ) {
              needsEnhance = true;
              enhance(node);
            }
          });
        } else if (mutation.type === 'attributes' && mutation.target instanceof HTMLElement) {
          if (mutation.target.classList.contains('jdgm-star')) paintStar(mutation.target);
        }
      }
      if (needsEnhance) enhance();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
